import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumUserRole',
  standalone: false,
})
export class EnumUserRolePipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = UserRoleSchema;
}
